import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import {
  getPolicy,
  getSafeguardingCategoriesForSCR,
  getSCRroles,
  getTraningCategoriesForSCR,
} from '../../pages/centeral-records/apiCalls'

interface Category {
  name: string
  id: string
  childrens: Category[]
}

interface SelectedState {
  [parentCategoryId: string]: string[]
}

interface NestedCheckboxProps {
  id: string
  category: string
  parentCategoryId: string
  selected: SelectedState
  handleChildChange: (parentCategoryId: string, categoryId: string) => void
  handleParentClick: (parentCategoryId: string, categoryId: string) => void
  visible: { [key: string]: boolean }
  childrens: Category[]
}

const NestedCheckbox = ({
  id,
  category,
  parentCategoryId,
  childrens,
  selected,
  handleChildChange,
  handleParentClick,
  visible,
}: NestedCheckboxProps) => (
  <div className="nested-checkbox">
    <label
      className="parent-checkbox flex items-center space-x-2 font-medium cursor-pointer"
      onClick={() => handleParentClick(parentCategoryId, id)}
    >
      <input
        type="checkbox"
        checked={selected[parentCategoryId]?.includes(id) || false}
        readOnly
        className="h-4 w-4 text-blue-500"
      />
      <span>{category}</span>
    </label>

    {visible[id] && (
      <div className="pl-6 mt-2 space-y-1">
        {childrens.map((child) => (
          <NestedCheckbox
            key={child.id}
            id={child.id}
            category={child.name}
            parentCategoryId={id}
            selected={selected}
            handleChildChange={handleChildChange}
            handleParentClick={handleParentClick}
            visible={visible}
            childrens={child.childrens}
          />
        ))}
      </div>
    )}
  </div>
)

interface TempProps {
  getValue: (selected: SelectedState) => void
}

export default function NestedCheckboxes({ getValue }: TempProps) {
  const [selected, setSelected] = useState<SelectedState>({})
  const [visible, setVisible] = useState<{ [key: string]: boolean }>({})
  const { data: trainingCategories } = useQuery(
    'trainingCategories',
    getTraningCategoriesForSCR
  )
  const { data: safeguardCategories } = useQuery(
    'safeguardCategories',
    getSafeguardingCategoriesForSCR
  )
  const policies = useQuery('policydata1', () => getPolicy())

  // const { data: policy } = useQuery('policy', getPolicy)

  const { data: roles } = useQuery('role', getSCRroles)

  const [filterCategories, setFilterCategories] = useState<Category[]>([])

  useEffect(() => {
    const updatedCategories: Category[] = [
      {
        id: 'profile',
        name: 'Profile & Employment',
        childrens: [
          {
            id: 'all_360',
            name: '360 Role',
            childrens: [
              { id: 'all_child_360', name: 'All', childrens: [] },
              ...(roles?.map((r) => ({
                id: r.id,
                name: r.role,
                childrens: [],
              })) || []),
            ],
          },
          {
            id: 'all_work_status',
            name: 'Work Status',
            childrens: [
              { id: 'all_child_work', name: 'All', childrens: [] },
              { id: 'full_time', name: 'Full Time', childrens: [] },
              { id: 'part_time', name: 'Part Time', childrens: [] },
            ],
          },
        ],
      },
      {
        id: 'training',
        name: 'Training',
        childrens: [
          { id: 'all_training', name: 'All', childrens: [] },
          ...(trainingCategories?.data.map((i) => ({
            id: i.id,
            name: i.title,
            childrens: [],
          })) || []),
        ],
      },
      {
        id: 'safeguarding',
        name: 'Safeguarding',
        childrens: [
          { id: 'all_safeguard', name: 'All', childrens: [] },
          ...(safeguardCategories?.data.map((i) => ({
            id: i.id,
            name: i.title,
            childrens: [],
          })) || []),
        ],
      },
      {
        id: 'policies',
        name: 'Policies',
        childrens: [
          ...(policies?.data?.data?.map((i) => ({
            id: i.id,
            name: i.title,
            childrens: [],
          })) || []),
        ],
      },
    ]
    setFilterCategories(updatedCategories)
  }, [trainingCategories, safeguardCategories, roles])

  useEffect(() => {
    if (selected && getValue) {
      getValue(selected)
    }
  }, [selected, getValue])

  // const handleParentClick = (parentCategoryId: string, categoryId: string) => {
  //   setVisible((prev) => ({ ...prev, [categoryId]: !prev[categoryId] }))

  //   setSelected((prev) => {
  //     const newSelected = { ...prev }
  //     newSelected[parentCategoryId] = newSelected[parentCategoryId] || []

  //     const parentCategory = filterCategories.find(
  //       (c) => c.id === parentCategoryId
  //     )

  //     // Recursive function to find a category by ID
  //     const findCategory = (
  //       categories: Category[],
  //       id: string
  //     ): Category | undefined => {
  //       for (const category of categories) {
  //         if (category.id === id) return category
  //         const found = findCategory(category.childrens, id)
  //         if (found) return found
  //       }
  //       return undefined
  //     }

  //     const currentCategory = findCategory(
  //       parentCategory?.childrens || [],
  //       categoryId
  //     )

  //     // Recursive function to get all children IDs
  //     const getAllChildren = (category: Category): string[] =>
  //       category.childrens.reduce(
  //         (acc, child) => [...acc, child.id, ...getAllChildren(child)],
  //         [] as string[]
  //       )

  //     const isAllSelection = categoryId.startsWith('all_')

  //     if (newSelected[parentCategoryId].includes(categoryId)) {
  //       // Unselect category
  //       newSelected[parentCategoryId] = newSelected[parentCategoryId].filter(
  //         (id) => id !== categoryId
  //       )

  //       if (isAllSelection && currentCategory) {
  //         // Uncheck all related children of this "All" category
  //         const categoryChildren = getAllChildren(currentCategory)
  //         newSelected[parentCategoryId] = newSelected[parentCategoryId].filter(
  //           (id) => !categoryChildren.includes(id)
  //         )
  //       }
  //     } else {
  //       // Select category
  //       newSelected[parentCategoryId] = [
  //         ...newSelected[parentCategoryId],
  //         categoryId,
  //       ]

  //       if (isAllSelection && currentCategory) {
  //         // Select all children related to this "All" checkbox
  //         const categoryChildren = getAllChildren(currentCategory)
  //         newSelected[parentCategoryId] = Array.from(
  //           new Set([...newSelected[parentCategoryId], ...categoryChildren])
  //         )
  //       }
  //     }

  //     return newSelected
  //   })
  // }

  // const handleParentClick = (parentCategoryId: string, categoryId: string) => {
  //   setVisible((prev) => ({ ...prev, [categoryId]: !prev[categoryId] }))

  //   setSelected((prev) => {
  //     const newSelected = { ...prev }
  //     newSelected[parentCategoryId] = newSelected[parentCategoryId] || []

  //     const parentCategory = filterCategories.find(
  //       (c) => c.id === parentCategoryId
  //     )

  //     // Find the selected category within its parent
  //     const findCategory = (
  //       categories: Category[],
  //       id: string
  //     ): Category | undefined => {
  //       for (const category of categories) {
  //         if (category.id === id) return category
  //         const found = findCategory(category.childrens, id)
  //         if (found) return found
  //       }
  //       return undefined
  //     }

  //     const currentCategory = findCategory(
  //       parentCategory?.childrens || [],
  //       categoryId
  //     )

  //     // Check if the category is an "All" selection
  //     const isAllSelection = categoryId.startsWith('all_')

  //     if (newSelected[parentCategoryId].includes(categoryId)) {
  //       // Unselect the category
  //       newSelected[parentCategoryId] = newSelected[parentCategoryId].filter(
  //         (id) => id !== categoryId
  //       )

  //       if (!isAllSelection) {
  //         // If a child is unchecked, uncheck its direct "All" parent (not other groups)
  //         const parentSubcategory = parentCategory?.childrens.find((sub) =>
  //           sub.childrens.some((child) => child.id === categoryId)
  //         )
  //         if (parentSubcategory) {
  //           newSelected[parentCategoryId] = newSelected[
  //             parentCategoryId
  //           ].filter((id) => id !== parentSubcategory.id)
  //         }
  //       }

  //       // If "All" is unchecked, remove all its children recursively
  //       if (isAllSelection && currentCategory) {
  //         const getAllChildren = (category: Category): string[] =>
  //           category.childrens.reduce(
  //             (acc, child) => [...acc, child.id, ...getAllChildren(child)],
  //             [] as string[]
  //           )

  //         const categoryChildren = getAllChildren(currentCategory)
  //         newSelected[parentCategoryId] = newSelected[parentCategoryId].filter(
  //           (id) => !categoryChildren.includes(id)
  //         )
  //       }
  //     } else {
  //       // Select the category
  //       newSelected[parentCategoryId] = [
  //         ...newSelected[parentCategoryId],
  //         categoryId,
  //       ]

  //       if (isAllSelection && currentCategory) {
  //         // Add all related children recursively
  //         const getAllChildren = (category: Category): string[] =>
  //           category.childrens.reduce(
  //             (acc, child) => [...acc, child.id, ...getAllChildren(child)],
  //             [] as string[]
  //           )

  //         const categoryChildren = getAllChildren(currentCategory)
  //         newSelected[parentCategoryId] = Array.from(
  //           new Set([...newSelected[parentCategoryId], ...categoryChildren])
  //         )
  //       }
  //     }

  //     return newSelected
  //   })
  // }

  const handleParentClick = (parentCategoryId: string, categoryId: string) => {
    setVisible((prev) => ({ ...prev, [categoryId]: !prev[categoryId] }))

    setSelected((prev) => {
      const newSelected = { ...prev }
      newSelected[parentCategoryId] = newSelected[parentCategoryId] || []

      const parentCategory = filterCategories.find(
        (c) => c.id === parentCategoryId
      )
      const currentCategory = parentCategory?.childrens.find(
        (c) => c.id === categoryId
      )

      // Identify if this is a subgroup (e.g., all_360 vs all_work_status)
      const isAllSelection = categoryId.startsWith('all_')
      // const isChildCategory = parentCategory?.childrens.some((c) =>
      //   c.childrens.some((child) => child.id === categoryId)
      // )

      if (newSelected[parentCategoryId].includes(categoryId)) {
        // Unselect the category
        newSelected[parentCategoryId] = newSelected[parentCategoryId].filter(
          (id) => id !== categoryId
        )

        if (!isAllSelection) {
          // If a child is unchecked, uncheck only its own "all_" (not affecting other subcategories)
          const parentSubcategory = parentCategory?.childrens.find((sub) =>
            sub.childrens.some((child) => child.id === categoryId)
          )
          if (parentSubcategory) {
            newSelected[parentCategoryId] = newSelected[
              parentCategoryId
            ].filter((id) => id !== parentSubcategory.id)
          }
        }

        // If "All" is unchecked, remove all children related to its own subgroup only
        if (isAllSelection) {
          const categoryChildren =
            currentCategory?.childrens.map((child) => child.id) || []
          newSelected[parentCategoryId] = newSelected[parentCategoryId].filter(
            (id) => !categoryChildren.includes(id)
          )
        }
      } else {
        // Select the category
        newSelected[parentCategoryId] = [
          ...newSelected[parentCategoryId],
          categoryId,
        ]

        if (isAllSelection) {
          // Add all related children for its subgroup only
          const categoryChildren =
            currentCategory?.childrens.map((child) => child.id) || []
          newSelected[parentCategoryId] = Array.from(
            new Set([...newSelected[parentCategoryId], ...categoryChildren])
          )
        }
      }

      return newSelected
    })
  }

  // const handleParentClick = (parentCategoryId: string, categoryId: string) => {
  //   setVisible((prev) => ({ ...prev, [categoryId]: !prev[categoryId] }))

  //   setSelected((prev) => {
  //     const newSelected = { ...prev }
  //     newSelected[parentCategoryId] = newSelected[parentCategoryId] || []

  //     if (newSelected[parentCategoryId].includes(categoryId)) {
  //       // If the category is already selected, unselect it using filter
  //       newSelected[parentCategoryId] = newSelected[parentCategoryId].filter(
  //         (id) => id !== categoryId
  //       )

  //       // If a child is unchecked, also uncheck "all_" tab
  //       if (!categoryId.includes('all_')) {
  //         newSelected[parentCategoryId] = newSelected[parentCategoryId].filter(
  //           (id) => id !== 'all_' + parentCategoryId
  //         )
  //       }

  //       // If "All" is unchecked, uncheck all child categories as well
  //       if (categoryId.includes('all_')) {
  //         const category = filterCategories.find(
  //           (c) => c.id === parentCategoryId
  //         )
  //         if (category) {
  //           newSelected[parentCategoryId] = newSelected[
  //             parentCategoryId
  //           ].filter(
  //             (id) => !category.childrens.some((child) => child.id === id)
  //           )
  //         }
  //       }
  //     } else {
  //       // If the category is not selected, select it
  //       newSelected[parentCategoryId] = [
  //         ...newSelected[parentCategoryId],
  //         categoryId,
  //       ]

  //       // If "All" is checked, check all child categories as well
  //       if (categoryId.includes('all_')) {
  //         const category = filterCategories.find(
  //           (c) => c.id === parentCategoryId
  //         )
  //         if (category) {
  //           const childIds = category.childrens.map((child) => child.id)
  //           newSelected[parentCategoryId] = Array.from(
  //             new Set([...newSelected[parentCategoryId], ...childIds])
  //           )
  //         }
  //       }
  //     }

  //     return newSelected
  //   })
  // }

  return (
    <div
      className="p-4  w-[100%]"
      style={{ height: '250px', overflowY: 'scroll' }}
    >
      <h2 className="text-lg font-semibold mb-4">Export Data</h2>
      <div className="space-y-4">
        {filterCategories.map(({ id, name, childrens }) => (
          <NestedCheckbox
            key={id}
            id={id}
            category={name}
            parentCategoryId={id}
            selected={selected}
            handleChildChange={handleParentClick}
            handleParentClick={handleParentClick}
            visible={visible}
            childrens={childrens}
          />
        ))}
      </div>
    </div>
  )
}
